var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.9977759,5 L12,5.00222657 L12,5 L11.9977759,5 Z M10,5 L8,5 L8,13 L13,13 L13,7.93969727 L10,7.93969727 L10,5 Z M13,6.00333985 L13,6 L12.9966639,6 L13,6.00333985 Z M12.9644495,5 L13,5 L13,5.03619385 L15,7.0723877 L15,14 C15,14.5522847 14.5522847,15 14,15 L7,15 C6.44771525,15 6,14.5522847 6,14 L6,4 C6,3.44771525 6.44771525,3 7,3 L11,3 L12.9644495,5 Z M5,2 L4,2 L4,10 L5,10 L5,12 L3,12 C2.44771525,12 2,11.5522847 2,11 L2,1 C2,0.44771525 2.44771525,1.01453063e-16 3,0 L7,0 L8.96444951,2 L5,2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDocument);
export default __webpack_public_path__ + "static/media/copy-document.55bd2348db1b390854c50e95bb41aee6.svg";
export { ForwardRef as ReactComponent };